import { AlertCircle, Clock } from 'lucide-react';
import { motion } from 'framer-motion';

interface MessageRetryIndicatorProps {
  status: 'pending' | 'failed';
  onRetry?: () => void;
}

export function MessageRetryIndicator({ status, onRetry }: MessageRetryIndicatorProps) {
  if (status === 'pending') {
    return (
      <motion.div
        initial={{ opacity: 0, scale: 0.8 }}
        animate={{ opacity: 1, scale: 1 }}
        className="flex items-center gap-1 mt-0.5"
      >
        <Clock className="h-3 w-3 text-muted-foreground/50 animate-pulse" />
        <span className="text-[10px] text-muted-foreground/50">Sending…</span>
      </motion.div>
    );
  }

  return (
    <motion.button
      initial={{ opacity: 0, scale: 0.8 }}
      animate={{ opacity: 1, scale: 1 }}
      whileTap={{ scale: 0.9 }}
      onClick={(e) => { e.stopPropagation(); onRetry?.(); }}
      className="flex items-center gap-1 mt-0.5 cursor-pointer"
    >
      <AlertCircle className="h-3.5 w-3.5 text-destructive" />
      <span className="text-[10px] text-destructive font-medium">Tap to retry</span>
    </motion.button>
  );
}
